import "regenerator-runtime/runtime";
import $ from "jquery";

import axios from "axios";

import {CHANGE_MATERIAL_URL_EVENT_NAME, dispatchEvent, GET_NEXT_MATERIAL_EVENT_NAME} from '../../../common/events';
import {PARTNER_RIGHT_WIDGET} from "Core/links";
import twemoji from "twemoji";
import {hashtagWidth} from "./hashtags-width";
import {getClientIdentificator} from "../../common/clientIdentificator/clientIdentificator";
import {eternalGetNextHandler} from "../../common/dataLayer/data-layer-metrica-handlers";
import {handleSocialSection} from "./section-social-handler";
import {lazyLoad} from '../embeds/lazy-load';
import {generalHandlersAfterLoad} from '../../common/ad/general-handlers';
import {partnerWidgetGeneralHandlersAfterLoad} from "../partners-widget/partner-widget-general-handlers";
import {sendMaterialData} from "../partners-widget/cross-recommender";

const SELECTOR_WITH_DATA_URL = '.material-content__sections-wrapper:last';
const materialInfoMap = {};
const eternalGetNextMap = {};
const COUNT_PAGE_INDEX = 'countPage';

let getNextInProcess = false;

let prevScrollPosition = 0;
let needAction = true;

export const eternalScrollOnReadyHandlers = () => {
    window.localStorage.setItem(COUNT_PAGE_INDEX, 0);
    incrementCountPage();

    if ($(SELECTOR_WITH_DATA_URL).length === 0) {
        return;
    }

    getClientIdentificator()
        .then((data) => {
            markMaterialAsViewed($(SELECTOR_WITH_DATA_URL).data('id'));
            saveCurrentInfo();
        });
};

export const addShareBtn = (entityId, html) => {
    if (materialInfoMap[entityId] !== undefined) {
        materialInfoMap[entityId]['shareBtnHtml'] = html;
    }
};

export const getCurrentMaterial = () => {
    let currentMaterialContainer = null;

    $('.material-content__parts-wrapper').each(function () {
        if (location.href.indexOf(materialInfoMap[$(this).data('id')].dto.link) !== -1) {
            currentMaterialContainer = $(this);
        }
    });

    return currentMaterialContainer;
};

export const scrollGetNextHandler = () => {
    const scrollPercentage = ($(window).scrollTop() / ($(document).height() - $(window).height())) * 100;

    if (scrollPercentage > 75 && !getNextInProcess) {
        needAction = prevScrollPosition < scrollPercentage;

        if (prevScrollPosition === 0 || needAction) {
            getNext();

            prevScrollPosition = scrollPercentage;
        }
    }

    $('.material-content__parts-wrapper').each(function () {
        const info = materialInfoMap[$(this).data('id')];

        if (
            $(window).scrollTop() >= $(this).offset().top
            &&
            $(window).scrollTop() <= $(this).offset().top + $(this).height()
            &&
            location.href.indexOf(info.dto.link) === -1
        ) {
            window.history.replaceState(
                {},
                info.meta.title,
                info.dto.link
            );

            changeSliderHashtag($(this).data('id'));

            $('title').text(info.meta.title);
            $('meta[name="keywords"]').attr('content', info.meta.keywords);
            $('meta[name="description"]').attr('content', info.meta.description);
            $('meta[property="og:title"]').attr('content', info.dto.headline);
            $('meta[property="og:url"]').attr('content', info.dto.link);
            $('meta[property="og:image"]').attr('content', info.dto.sharePhotoLink);
            $('meta[property="og:image:alt"]').attr('content', info.dto.headline);
            $('meta[property="og:description"]').attr('content', info.dto.description);
            $('meta[name="twitter:title"]').attr('content', info.dto.headline);
            $('meta[name="twitter:description"]').attr('content', info.dto.description);
            $('meta[name="twitter:image"]').attr('content', info.dto.sharePhotoLink);
            $('meta[name="twitter:image:alt"]').attr('content', info.dto.headline);
            $('meta[name="twitter:url"]').attr('content', info.dto.link);
            $('meta[name="vk:image"]').attr('content', info.dto.vkImageSharePhotoLink);
            // $('.material-content-header-sharing__buttons.share-btn-container').html(info.shareBtnHtml);
            // $('.material-content-header-sharing__buttons.share-btn-container').data('entityId', $(this).data('id'));

            dispatchEvent(CHANGE_MATERIAL_URL_EVENT_NAME, {
                detail: {
                    entityId: $(this).data('id')
                }
            });

            if (eternalGetNextMap[$(this).data('id')] === undefined) {
                eternalGetNextMap[$(this).data('id')] = true;

                eternalGetNextHandler();
            }
        }
    });
};

const saveCurrentInfo = () => {
    const id = $('.material-content__parts-wrapper:first').data('id');

    dispatchEvent(CHANGE_MATERIAL_URL_EVENT_NAME, {
        detail: {
            entityId: id
        }
    });

    materialInfoMap[id] = {
        meta: {
            title: document.title,
            keywords: $('meta[name="keywords"]').attr('content'),
            description: $('meta[name="description"]').attr('content')
        },
        dto: {
            link: $('meta[property="og:url"]').attr('content'),
            headline: $('meta[property="og:title"]').attr('content'),
            sharePhotoLink: $('meta[property="og:image"]').attr('content'),
            description: $('meta[property="og:description"]').attr('content'),
            vkImageSharePhotoLink: $('meta[name="vk:image"]').attr('content')
        },
        shareBtnHtml: $('.material-content-header-sharing__buttons.share-btn-container').html()
    };
};

const markMaterialAsViewed = async (materialId) => {
    if ($(SELECTOR_WITH_DATA_URL).length === 0) {
        return;
    }

    axios.post(
        $(SELECTOR_WITH_DATA_URL).data('createUrl'),
        {materialId: materialId, clientId: await getClientIdentificator()}
    );
};

const getNext = async () => {
    if ($(SELECTOR_WITH_DATA_URL).length === 0) {
        return;
    }

    let clientId = await getClientIdentificator();

    getNextInProcess = true;

    if ($('.material-content__parts-wrapper:first').data('noEternal') !== undefined) {
        return;
    }

    const elementData = $(SELECTOR_WITH_DATA_URL).data();
    axios.defaults.headers.common['Accept'] = window.httpAccept || '';
    axios.get(
        elementData['nextUrl'],
        {
            params: {
                clientId: clientId,
                isNews: elementData['isNews'],
                isCentered: elementData['isCentered']
            }
        }
    )
        .then((response) => {
            getNextInProcess = false;

            const element = $(response.data.html);

            element.find('.material-content-header-sharing__buttons.share-btn-container').append(response.data.shareBtnHtml);
            materialInfoMap[response.data.id] = response.data;

            element.data('id', response.data.id);

            if ($('.material-content__left-part').length > 0) {
                $('.material-content__left-part').append(element)
            } else {
                $('.material-content').append(element);
            }

            sendMaterialData(response.data.id);
            updatePartnerRightWidget();
            partnerWidgetGeneralHandlersAfterLoad();

            twemoji.parse(document.body);

            dispatchEvent(GET_NEXT_MATERIAL_EVENT_NAME, {
                detail: {
                    materialId: response.data.id
                }
            });

            hashtagWidth();
            incrementCountPage();
            generalHandlersAfterLoad();
            $.ajax({
                url: '/dist/assets/loading_attribute_polyfill.js',
                dataType: 'script',
                async: true
            });
            $.ajax({
                url: '//www.instagram.com/embed.js',
                dataType: 'script',
                async: true
            }).then(() => {
                window.instgrm.Embeds.process();
            });

            handleSocialSection();
            markMaterialAsViewed($(SELECTOR_WITH_DATA_URL).data('id'));

            lazyLoad();
        });
};

const incrementCountPage = () => {
    let countPage = 0;

    if (window.localStorage.getItem(COUNT_PAGE_INDEX) !== null) {
        countPage = window.localStorage.getItem(COUNT_PAGE_INDEX);
    }

    countPage++;

    window.localStorage.setItem(COUNT_PAGE_INDEX, countPage);
};

const changeSliderHashtag = (id) => {
    $('.hash-tags-sidebar__inner').empty();

    $('.material-content__parts-wrapper[data-id="' + id + '"]').find('.material-content-hashtag--hidden a').each(function () {
        const tag = $('<div class="hash-tag"></div>').append($(this).clone());
        $('.hash-tags-sidebar__inner').append(tag);
    });
};

const updatePartnerRightWidget = () => {
    axios.get(PARTNER_RIGHT_WIDGET)
        .then((response) => {
            $('.partners-widget-wrapper--sidebar').html(response.data);
        });
};
